// extracted by mini-css-extract-plugin
export default {"activityScheduledIcon":"ActivityScheduled_activityScheduledIcon__zeRYI"};